import React from 'react'
import { DashboardPage } from './pages/DashboardPage'

const Dashboard: React.FC = () => {
  return <DashboardPage />
}

export default Dashboard 